module.exports = __webpack_public_path__ + "static/Dona-Bold-462793be798d263d169838b1e1f7c0c4.woff";